import React, { useState } from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardActions from '@material-ui/core/CardActions';
import LinearProgress from '@material-ui/core/LinearProgress';
import Typography from '@material-ui/core/Typography';
import NavigationButtons from './NavigationButtons';

import { useFetchAppointmentPdf } from 'Features/ContractRelease/Services/release.service';
import styles from './pre-ex6.module.css';

const ViewPDF = ({ row, handleActive }) => {
	const [pdf, setPdf] = useState(null);
	const { qualificationYear : year, type, appointmentId } = row;

	const { isLoading, isSuccess } = useFetchAppointmentPdf(year, type, appointmentId, setPdf);
	document.title = `Contract Management - ${row.title} (${row.markingTeamCode})`;

	return (
		<>
			<Card className={styles.view_pdf_root} variant="outlined">
				<CardHeader
					title={
						<Typography noWrap component="h2">
							{row.title}
						</Typography>
					} 
					subheader={
						<Typography noWrap component="h2">
							({row.markingTeamCode})
						</Typography>						
					} 
					action={<NavigationButtons row={row} action={handleActive} />}>					
				</CardHeader>
				<CardMedia className={styles.media} title="Contract PDF">
					{isLoading ? (
						<LinearProgress color="secondary" />
					) : !isSuccess ? (
						<div>Unable to Retrieve PDF</div>
					) : (
						<object width="100%" height="370" type="application/pdf" data={`data:application/pdf;base64,${pdf}`}>
							This is supposed to be a PDF
						</object>
					)}
				</CardMedia>
				<CardActions></CardActions>
			</Card>
		</>
	);
};

export default ViewPDF;
